/** MCAP file magic at both the head and tail of a valid file. */
export const MCAP_MAGIC = new Uint8Array([0x89, 0x4d, 0x43, 0x41, 0x50, 0x30, 0x0d, 0x0a]);

export const MCAP_FOOTER_BYTES = 37;
export const MCAP_SUMMARY_OFFSET_RECORD_BYTES = 26;
export const MCAP_MAX_HEADER_BYTES = 4 * 1024;
export const MCAP_MAX_SCHEMA_GROUP_BYTES = 1024 * 1024;
export const MCAP_MAX_REPAIR_TAIL_BYTES = 16;
export const MCAP_RECORD_PREFIX_BYTES = 9;
export const MCAP_CHUNK_HEADER_BYTES = 32;
export const MCAP_MAX_COMPRESSION_NAME_BYTES = 1024;
export const MCAP_DEVICE_ENCRYPTED_COMPRESSION = 'zstd+aes-gcm';
